export enum PERIOD_TYPE {
    DAY = "DAY",
    WEEK = "WEEK",
    MONTH = "MONTH",
    YEAR = "YEAR"
};

export const PERIOD_TYPE_TRANSLATION: Record<PERIOD_TYPE, string> = {
    [PERIOD_TYPE.DAY]: "Día",
    [PERIOD_TYPE.WEEK]: "Semana",
    [PERIOD_TYPE.MONTH]: "Mes",
    [PERIOD_TYPE.YEAR]: "Año",
};

export enum SHIPMENT_METHOD {
    CITYPAQ = "CITYPAQ",
    IN_PERSON_DELIVERY = "IN_PERSON_DELIVERY",
    HOME_DELIVERY = "HOME_DELIVERY",
};

export const SHIPMENT_METHOD_TRANSLATION: Record<SHIPMENT_METHOD, string> = {
    [SHIPMENT_METHOD.CITYPAQ]: "Punto de recogida",
    [SHIPMENT_METHOD.IN_PERSON_DELIVERY]: "En persona",
    [SHIPMENT_METHOD.HOME_DELIVERY]: "A domicilio",
};

export const SHIPMENT_METHOD_ICON: Record<SHIPMENT_METHOD, string> = {
    [SHIPMENT_METHOD.CITYPAQ]: "cube-outline",
    [SHIPMENT_METHOD.IN_PERSON_DELIVERY]: "account-outline",
    [SHIPMENT_METHOD.HOME_DELIVERY]: "truck-outline",
};

export enum PRODUCT_CATEGORY {
    CARS = 'Vehículos',
    CLOTHES = 'Moda',
    SPORTS = 'Deporte',
    HEALTH = 'Salud',
    TECHNOLOGY = 'Tecnología',
    HOME = 'Hogar y jardín',
    CHILD = 'Niños y bebés',
    LEISURE = 'Cine, libros y música'
};

export default interface Post {
    _id: string;
    user: string;
    name: string;
    description: string;
    price: number;
    photo?: string;
    period: PERIOD_TYPE;
    buyPossibility: boolean;
    media: string[];
    deposit: number;
    weight: number;
    categories: string[];
    shipmentMethods: SHIPMENT_METHOD[];
    buyPrice: number;
    address: string;
    rentHistory: string[];
    reviews: string[];
    amount?: number;
}